/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportCostsByLocationRollup
 */
export interface ReportCostsByLocationRollup {
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocationRollup
     */
    employees: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocationRollup
     */
    shifts: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocationRollup
     */
    hoursScheduled: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocationRollup
     */
    hoursWorked: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocationRollup
     */
    costsScheduled: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByLocationRollup
     */
    costsWorked: number;
}

/**
 * Check if a given object implements the ReportCostsByLocationRollup interface.
 */
export function instanceOfReportCostsByLocationRollup(value: object): value is ReportCostsByLocationRollup {
    if (!('employees' in value) || value['employees'] === undefined) return false;
    if (!('shifts' in value) || value['shifts'] === undefined) return false;
    if (!('hoursScheduled' in value) || value['hoursScheduled'] === undefined) return false;
    if (!('hoursWorked' in value) || value['hoursWorked'] === undefined) return false;
    if (!('costsScheduled' in value) || value['costsScheduled'] === undefined) return false;
    if (!('costsWorked' in value) || value['costsWorked'] === undefined) return false;
    return true;
}

export function ReportCostsByLocationRollupFromJSON(json: any): ReportCostsByLocationRollup {
    return ReportCostsByLocationRollupFromJSONTyped(json, false);
}

export function ReportCostsByLocationRollupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportCostsByLocationRollup {
    if (json == null) {
        return json;
    }
    return {
        
        'employees': json['employees'],
        'shifts': json['shifts'],
        'hoursScheduled': json['hoursScheduled'],
        'hoursWorked': json['hoursWorked'],
        'costsScheduled': json['costsScheduled'],
        'costsWorked': json['costsWorked'],
    };
}

  export function ReportCostsByLocationRollupToJSON(json: any): ReportCostsByLocationRollup {
      return ReportCostsByLocationRollupToJSONTyped(json, false);
  }

  export function ReportCostsByLocationRollupToJSONTyped(value?: ReportCostsByLocationRollup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employees': value['employees'],
        'shifts': value['shifts'],
        'hoursScheduled': value['hoursScheduled'],
        'hoursWorked': value['hoursWorked'],
        'costsScheduled': value['costsScheduled'],
        'costsWorked': value['costsWorked'],
    };
}

